import { render, staticRenderFns } from "./SearchResultExport.vue?vue&type=template&id=19151f82"
import script from "./SearchResultExport.vue?vue&type=script&lang=js"
export * from "./SearchResultExport.vue?vue&type=script&lang=js"
import style0 from "./SearchResultExport.vue?vue&type=style&index=0&id=19151f82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports